// useSelectors.ts
import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _a.responseOneQuote, errorOneQuote = _a.errorOneQuote, loadingOneQuote = _a.loadingOneQuote;
    var _b = useSelector(function (state) { return ({
        loadingUpdateQuote: state.UpdateQuote.loadingUpdateQuote,
        errorUpdateQuote: state.UpdateQuote.errorUpdateQuote,
    }); }), loadingUpdateQuote = _b.loadingUpdateQuote, errorUpdateQuote = _b.errorUpdateQuote;
    var _c = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
    }); }), responseIdentificationType = _c.responseIdentificationType, errorIdentificationType = _c.errorIdentificationType;
    var _d = useSelector(function (state) { return ({
        responseCatalogGender: state.Plan.responseCatalogGender,
        errorCatalogGender: state.Plan.errorCatalogGender,
    }); }), responseCatalogGender = _d.responseCatalogGender, errorCatalogGender = _d.errorCatalogGender;
    var _e = useSelector(function (state) { return ({
        responseCountries: state.Countries.responseCountries,
        errorCountries: state.Countries.errorCountries,
    }); }), responseCountries = _e.responseCountries, errorCountries = _e.errorCountries;
    var _f = useSelector(function (state) { return ({
        responseRegion: state.Region.responseRegion,
        errorRegion: state.Region.errorRegion,
    }); }), responseRegion = _f.responseRegion, errorRegion = _f.errorRegion;
    var _g = useSelector(function (state) {
        var _a;
        return ({
            responsePlans: (_a = state.Plans.responsePlans) === null || _a === void 0 ? void 0 : _a.data,
            errorPlans: state.Plans.errorPlans,
            loadingPlans: state.Plans.loadingPlans,
        });
    }), responsePlans = _g.responsePlans, errorPlans = _g.errorPlans, loadingPlans = _g.loadingPlans;
    var _h = useSelector(function (state) { return ({
        responseInsured: state.Insured.responseInsured,
        errorInsured: state.Insured.errorInsured,
        loadingInsured: state.Insured.loadingInsured,
    }); }), responseInsured = _h.responseInsured, errorInsured = _h.errorInsured, loadingInsured = _h.loadingInsured;
    var _j = useSelector(function (state) { return ({
        responsePlan: state.Plan.responsePlan,
        errorPlan: state.Plan.errorPlan,
        loading: state.Plan.loadingPlan,
    }); }), responsePlan = _j.responsePlan, errorPlan = _j.errorPlan, loading = _j.loading;
    var _k = useSelector(function (state) { return ({
        responseUpdatePerson: state.Person.responseUpdatePerson,
        errorUpdatePerson: state.Person.errorUpdatePerson,
        loadingUpdatePerson: state.Person.loadingUpdatePerson,
    }); }), responseUpdatePerson = _k.responseUpdatePerson, errorUpdatePerson = _k.errorUpdatePerson, loadingUpdatePerson = _k.loadingUpdatePerson;
    var _l = useSelector(function (state) { return ({
        responseBenefit: state.Beneficiary.responseBenefit,
        errorBenefit: state.Beneficiary.errorBenefit,
        loadingBenefit: state.Beneficiary.loadingBenefit,
    }); }), responseBenefit = _l.responseBenefit, errorBenefit = _l.errorBenefit, loadingBenefit = _l.loadingBenefit;
    var _m = useSelector(function (state) { return ({
        responseBeneficiary: state.Beneficiary.responseBeneficiary,
        errorBeneficiary: state.Beneficiary.errorBeneficiary,
        loadingBeneficiary: state.Beneficiary.loadingBeneficiary,
    }); }), responseBeneficiary = _m.responseBeneficiary, errorBeneficiary = _m.errorBeneficiary, loadingBeneficiary = _m.loadingBeneficiary;
    var _o = useSelector(function (state) { return ({
        responsePatchBeneficiary: state.Beneficiary.responsePatchBeneficiary,
        errorPatchBeneficiary: state.Beneficiary.errorPatchBeneficiary,
        loadingPatchBeneficiary: state.Beneficiary.loadingPatchBeneficiary,
    }); }), responsePatchBeneficiary = _o.responsePatchBeneficiary, errorPatchBeneficiary = _o.errorPatchBeneficiary, loadingPatchBeneficiary = _o.loadingPatchBeneficiary;
    var _p = useSelector(function (state) { return ({
        responsePostInsured: state.Insured.responsePostInsured,
        errorPostInsured: state.Insured.errorPostInsured,
        loadingPostInsured: state.Insured.loadingPostInsured,
    }); }), responsePostInsured = _p.responsePostInsured, errorPostInsured = _p.errorPostInsured, loadingPostInsured = _p.loadingPostInsured;
    var _q = useSelector(function (state) { return ({
        responsePatchInsured: state.Insured.responsePatchInsured,
        errorPatchInsured: state.Insured.errorPatchInsured,
        loadingPatchInsured: state.Insured.loadingPatchInsured,
    }); }), responsePatchInsured = _q.responsePatchInsured, errorPatchInsured = _q.errorPatchInsured, loadingPatchInsured = _q.loadingPatchInsured;
    var _r = useSelector(function (state) {
        var _a;
        return ({
            responsePageActionFlags: (_a = state.PageActionFlags.responsePageActionFlags) === null || _a === void 0 ? void 0 : _a.data,
            errorPageActionFlags: state.PageActionFlags.errorPageActionFlags,
            loadingPageActionFlags: state.PageActionFlags.loadingPageActionFlags,
        });
    }), responsePageActionFlags = _r.responsePageActionFlags, errorPageActionFlags = _r.errorPageActionFlags, loadingPageActionFlags = _r.loadingPageActionFlags;
    var _s = useSelector(function (state) {
        var _a;
        return ({
            responseOneProject: (_a = state.Project.responseOneProject) === null || _a === void 0 ? void 0 : _a.data,
            errorOneProject: state.Project.errorOneProject,
            loadingOneProject: state.Project.loadingOneProject,
        });
    }), responseOneProject = _s.responseOneProject, errorOneProject = _s.errorOneProject, loadingOneProject = _s.loadingOneProject;
    return {
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
        loadingUpdateQuote: loadingUpdateQuote,
        errorUpdateQuote: errorUpdateQuote,
        responseIdentificationType: responseIdentificationType,
        errorIdentificationType: errorIdentificationType,
        responseCatalogGender: responseCatalogGender,
        errorCatalogGender: errorCatalogGender,
        responsePlan: responsePlan,
        errorPlan: errorPlan,
        loading: loading,
        responseCountries: responseCountries,
        errorCountries: errorCountries,
        responseRegion: responseRegion,
        errorRegion: errorRegion,
        responsePlans: responsePlans,
        errorPlans: errorPlans,
        loadingPlans: loadingPlans,
        responseInsured: responseInsured,
        errorInsured: errorInsured,
        responsePostInsured: responsePostInsured,
        errorPostInsured: errorPostInsured,
        loadingPostInsured: loadingPostInsured,
        responsePatchInsured: responsePatchInsured,
        errorPatchInsured: errorPatchInsured,
        loadingPatchInsured: loadingPatchInsured,
        responseUpdatePerson: responseUpdatePerson,
        errorUpdatePerson: errorUpdatePerson,
        loadingUpdatePerson: loadingUpdatePerson,
        responseBenefit: responseBenefit,
        errorBenefit: errorBenefit,
        loadingBenefit: loadingBenefit,
        responsePatchBeneficiary: responsePatchBeneficiary,
        errorPatchBeneficiary: errorPatchBeneficiary,
        loadingPatchBeneficiary: loadingPatchBeneficiary,
        responseBeneficiary: responseBeneficiary,
        errorBeneficiary: errorBeneficiary,
        loadingBeneficiary: loadingBeneficiary,
        responsePageActionFlags: responsePageActionFlags,
        errorPageActionFlags: errorPageActionFlags,
        loadingPageActionFlags: loadingPageActionFlags,
        responseOneProject: responseOneProject,
        errorOneProject: errorOneProject,
        loadingOneProject: loadingOneProject,
        loadingInsured: loadingInsured,
    };
};
export default useSelectors;
